import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';

const root = (root: ReduxStore) => root;
export const abTests = createSelector(root, state => state?.abTests || []);
